import { Loader } from "../../../components/Loader/Loader";
import { useEffect } from "react";
import { useInitialUrlSearchParams } from "../../../hooks/useInitialUrlSearchParams";
import { RouterPaths, URL_SEARCH_PARAMS } from "../../../app/appConstants";
import appHistory from "../../../app/appHistory";
import { connect } from "react-redux";
import { autoLoginAction } from "../loginActions";

function AutoLogin(props) {
    const {autoLoginAction} = props;
    const {code, email} = useInitialUrlSearchParams([
        URL_SEARCH_PARAMS.CODE,
        URL_SEARCH_PARAMS.EMAIL,
    ], false);
    
    useEffect(() => {
        if (!code || !email) {
            appHistory.push(RouterPaths.brokenLink);
            return;
        }
        autoLoginAction({ code, email });
    }, [autoLoginAction, code, email]);

    return <Loader show/>
}

const mapDispatchToProps = {
    autoLoginAction,
}

export default connect(null, mapDispatchToProps)(AutoLogin);
